
import { Component, Inject } from '@angular/core';

import { PORTAL_DATA } from '../../../services/overlay.service';
import { TabItem } from '../../shared/bb-page-header/bb-page-header.component';
import { Subject } from 'rxjs';

@Component({
	selector: 'bb-menu-panel',
	templateUrl: './bb-menu-panel.component.html',
	styleUrls: ['./bb-menu-panel.component.scss']
})
export class BbMenuPanelComponent {
	public tabItems: TabItem[];
	private closeMenuPanelSubject: Subject<void>;

	constructor(@Inject(PORTAL_DATA) public data: any) {
		this.tabItems = data.tabItems;
		this.closeMenuPanelSubject = data.closeMenuPanelSubject;
	}

	closeMenuPanel() {
		if (this.closeMenuPanelSubject) {
			this.closeMenuPanelSubject.next();
		}
	}
}
